import { InlineNotification } from "@carbon/react";
import { ServerErrorType } from "@flaminem/utils";
import React from "react";

type InlineError = {
  title?: string;
  message: string;
  className?: string;
  hideCloseButton?: boolean;
  type?: ServerErrorType;
};

// Used to display an error as a notifications with a title, subtitle and a type (error or warning)
const InlineError: React.FC<InlineError> = ({
  message,
  title,
  className,
  type,
  hideCloseButton = true,
}) => {
  return (
    <InlineNotification
      className={`${className} !max-w-full`}
      title={title ?? ""}
      subtitle={message}
      kind={type === "Warning" ? "warning" : "error"}
      hideCloseButton={hideCloseButton}
    />
  );
};

export default InlineError;
